import { computed, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Report from "@/services/analytics/report";
import type { OpportunityDashboardRequestBody } from "./useOpportunityDashboardFilters";
import type { ProductPerformanceDto } from "@/dtos/ProductName.dto";

export function useProductPerformance(params: Ref<OpportunityDashboardRequestBody | null>) {
  const queryKey = computed(() => {
    const p = params.value;
    if (!p) return ["productPerformance", "disabled"];
    return ["productPerformance", JSON.stringify(p)];
  });

  const enabled = computed(() => {
    return params.value !== null && !!params.value.organizationId;
  });

  return useQuery<ProductPerformanceDto[]>({
    queryKey,
    queryFn: async () => {
      const p = params.value;
      if (!p) throw new Error("Parameters not ready");

      const response = await Report.getProductPerformance(p);

      if (response.data?.status && response.data?.data) {
        return response.data.data;
      }

      return [];
    },
    enabled,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
